// Сжимает фото перед загрузкой: до MAX_SIDE по большей стороне, JPEG.
// Фото с телефона на 5–8 МБ превращается в ~300–500 КБ, заодно HEIC → JPEG (где браузер умеет его открыть).
// Если браузер не смог открыть файл — возвращаем оригинал, сервер сам проверит тип.
const MAX_SIDE = 1600;
const QUALITY = 0.8;

export const compressImage = async (file) => {
  if (!file.type.startsWith("image/") || file.type === "image/gif") return file;

  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, width, height);
    bitmap.close?.();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", QUALITY));
    if (!blob || blob.size >= file.size) return file;

    const name = file.name.replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  } catch (error) {
    return file;
  }
};
